
<!--DRI Header -  Shows Points if displayOptions settings set.-->
<section class="header-stacked" *ngIf="showDriHeader" [ngClass]="{'mobile-menu--open' : isNavbarExpanded, 'mobile-menu--lg' : wrapNavMenu, 'mobile-menu--sm' : !wrapNavMenu}">
  <div class="header-stacked__container-fluid">
    <div class="header-stacked__row--top-nav">
      <div class="header-stacked__top-nav">
        <div class="header-stacked__my-account" *ngFor="let point of pointsAlternativeCurrencyArray; let i=index">
          <ul *ngIf="canShowPointsForDri(point.sub_type)">
            <li class="label" [innerHTML]="point.label+' :'"></li>
            <li class="value" [innerHTML]="point.balance"></li>
          </ul>
        </div>
        <ul class="header-stacked__balance">
          <li class="phone-number">
            <a href="tel:{{displayOptions?.program_phone_number}}">
              {{displayOptions?.program_phone_number}}
            </a>
          </li>
          <li class="account-link">
            <span class="dropdown">
              <a class="dropdown__toggle" (click)="myAccountMenu = !myAccountMenu"><span class="toggle--down"></span>My Account</a>
              <ul class="dropdown__content" *ngIf="myAccountMenu">
                <li><a href="{{displayOptions?.labels?.account_settings_label}}">{{displayOptions?.labels?.account_settings_label}}</a></li>
                <li><a href="{{displayOptions?.labels?.sign_out_href}}">{{displayOptions?.labels?.sign_out_label}}</a></li>
              </ul>
            </span>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="header-stacked__container">
    <div class="header-stacked__row--brand-nav">
      <button type="button" class="navbar-toggler" (click)="isNavbarExpanded = !isNavbarExpanded">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="header-stacked--align-left">
        <div class="header-stacked__logo">
          <a [href]="logoTargetUrl"><img [src]="displayOptions?.logos | pluck:'logo_image_url'| head" [alt]="displayOptions?.program_long_name" class="brand-logo"></a>
        </div>
      </div>
      <div class="header-stacked--align-right">
        <ul class="header-stacked__navbar-nav mobileHide" style="float: right">
          <li class="header-stacked__nav-item" *ngFor="let menu of displayOptions?.menus; let i=index">
            <span *ngIf="i<5">
              <a class="header-stacked__nav-link" [href]="menu.link_href | safeUrl" target="_blank" rel="noreferrer">{{menu.text_link}}</a>
            </span>
          </li>
        </ul>
        <ul class="header-stacked__navbar-nav desktop-hide">
          <li class="header-stacked__nav-item" *ngFor="let point of pointAlternativeCurrenyArray">
            <a class="header-stacked__nav-link">
              <span *ngIf="canShowPointsForDri(point.sub_type)">
                <strong [innerHTML]="point.label+':'"></strong>
                <strong [innerHTML]="point.balance"></strong>
              </span>


            </a>
          </li>
          <li class="header-stacked__nav-item">
            <a class="header-stacked__nav-link" href="tel:{{displayOptions?.program_phone_number}}">
              {{displayOptions?.program_phone_number}}
            </a>
          </li>
          <li class="header-stacked__nav-item" *ngFor="let menu of displayOptions?.menus" class="nav-item">
            <a [href]="menu.link_href | safeUrl" target="_blank" class="header-stacked__nav-link" rel="noreferrer">{{menu.text_link}}</a>
          </li>


          <li class="header-stacked__nav-item">
            <a [href]="displayOptions?.labels?.my_account_href | safeUrl" target="_blank" class="nav-link" rel="noreferrer">
              {{displayOptions?.labels?.account_settings_label}}
            </a>
          </li>
          <li class="header-stacked__nav-item">
            <a [href]="displayOptions?.labels?.sign_out_href | safeUrl" target="_blank" class="nav-link">
              {{displayOptions?.labels?.sign_out_label}}
            </a>
          </li>


        </ul>
      </div>
    </div>
  </div>
</section>

<!--Default Header -  DBC, Points-->
<section class="header__wrapper header__main" *ngIf="showDefaultHeader">
  <div class="container-fluid">
    <div class="header__container pad__btm--0 pad__top--0">
      <nav class="d-flex justify-content-end navbar navbar-expand-md navbar-light pad--none pad__top--10" *ngIf="showHeader">

        <div class="nav-logo mr-auto">
          <a [href]="logoTargetUrl">
            <img [src]="displayOptions?.logos | pluck: 'logo_image_url' | head"
                 [alt]="displayOptions?.program_long_name">
          </a>
        </div>
        <button class="navbar-toggler navbar-toggler-right"
                type="button"
                (click)="isMenuCollapsed = false">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="navbar-collapse flex-column align-items-end"
             [ngClass]="{'collapse': isMenuCollapsed}"
             id="mainNav">
          <div class="nav-logo d-block d-md-none">
            <a [href]="logoTargetUrl">
              <img [src]="displayOptions?.logos | pluck: 'logo_image_url' | head"
                   [alt]="displayOptions?.program_long_name" class='nav-logo-open'>
            </a>
            <button type="button" *ngIf="!isHamburguerMenu"
                    class="close-nav close d-block d-md-none"
                    (click)="isMenuCollapsed = true">
              <span aria-hidden="true"></span>
            </button>
            <a class="hamburger" role="button" (click)="isMenuCollapsed = true" *ngIf="isHamburguerMenu">
              <div class="hamburger__icon"></div>
            </a>
          </div>
          <div class="header__top-nav text-uppercase">
            <ul class="header__top-nav--my-account mrg__btm--20">
              <li>
                <span>{{programPhoneNumber}}</span>
              </li>
              <li class="divider">
                <a [href]="displayOptions?.labels?.my_account_href | safeUrl" target="_blank" class="my-account">
                  {{displayOptions?.labels?.account_settings_label}}
                </a>
              </li>
            </ul>
            <ul class="header__top-nav--credits" *ngIf="showPointsInHeader">
              <li>{{displayOptions?.labels?.points}}</li>
              <li class="header__top-nav--balance text-white">
                <div class="credits-bg">{{points | number}}</div>
              </li>
            </ul>
            <ul class="header__top-nav--credits" *ngIf="showDBCInHeader">
              <li>{{displayOptions?.labels?.dbc}}</li>
              <li class="header__top-nav--balance text-white">
                <div class="credits-bg">{{dbc | number}}</div>
              </li>
            </ul>
          </div>
          <ul class="navbar-nav">
            <li *ngFor="let menu of displayOptions?.menus" class="nav-item">
              <a [href]="menu.link_href | safeUrl" target="_blank" class="nav-link">{{menu.text_link}}</a>
            </li>
          </ul>
          <div class="navbar-nav__mobile">
            <ul class="header__top-nav--credits" *ngIf="showPointsInHeader">
              <li>{{displayOptions?.labels?.points}}</li>
              <li class="header__top-nav--balance bg__color--primary text-white">
                <div class="credits-bg">{{points | number}}</div>
              </li>
            </ul>
            <ul class="header__top-nav--credits" *ngIf="showDBCInHeader">
              <li>{{displayOptions?.labels?.dbc}}</li>
              <li class="header__top-nav--balance bg__color--primary text-white">
                <div class="credits-bg">{{dbc | number}}</div>
              </li>
            </ul>
            <div class="clearfix"></div>
            <ul class="navbar-nav">
              <li class="nav-item" *ngIf="isAccountSettingsLabelEndMenu">
                <a [href]="displayOptions?.labels?.my_account_href | safeUrl" target="_blank" class="nav-link">
                  {{displayOptions?.labels?.account_settings_label}}
                </a>
              </li>
              <li class="nav-item" *ngIf="!isPhoneEndMenu">
                <a href="tel:{{displayOptions?.program_phone_number}}" class="nav-link">{{programPhoneNumber}}</a>
              </li>
              <li *ngFor="let menu of displayOptions?.menus" class="nav-item">
                <a [href]="menu.link_href | safeUrl" target="_blank" class="nav-link">{{menu.text_link}}</a>
              </li>
              <li class="nav-item" *ngIf="isPhoneEndMenu">
                <a href="tel:{{displayOptions?.program_phone_number}}" class="nav-link text-center">{{programPhoneNumber}}</a>
              </li>
              <li class="nav-item" *ngIf="!isAccountSettingsLabelEndMenu">
                <a [href]="displayOptions?.labels?.my_account_href | safeUrl" target="_blank" class="nav-link">
                  {{displayOptions?.labels?.account_settings_label}}
                </a>
              </li>
            </ul>
          </div>
        </div>
        <!-- end navbar-collapse -->
      </nav>
    </div>
  </div>
</section>

<!--SOR Header-->
<section class="header-brand sor-brand" [ngClass]="{'mobile-menu--open' : isNavbarExpanded, 'mobile-menu--lg' : wrapNavMenu, 'mobile-menu--sm' : !wrapNavMenu}" *ngIf="showSorHeader">
  <div class="header-brand__container">

    <!--Mobile Hamburger Menu visibility controlled by code.  Display None in desktop-->
    <button type="button" class="navbar-toggler sor-brand" (click)="toggleMenuOpen()">
      <i class="fal " [ngClass]="{'fa-bars' : !isNavbarExpanded, 'fa-times' : isNavbarExpanded }"></i>
    </button>

    <!--Left Header Area - Logo Area Mobile-->
    <div class="header-brand--align-left">
      <span class="reward-points-label hidden-lg hidden-md" *ngIf="isLoyaltyCurrencyAllowed">
        {{loyaltyLabel}} : 
      </span>
      <span class="reward-points hidden-lg hidden-md" *ngIf="isLoyaltyCurrencyAllowed">
        {{loyalty}}
      </span>

      <div class="header-brand__logo">
        <a ui-sref="index">
          <img [src]="mainLogo" [alt]="displayOptions?.program_long_name"
               class="brand-logo">
        </a>
      </div>

      <!--Mobile Avatar for Mobile-->
      <ul class="hidden-md hidden-lg">
        <li class="header-bran__nav-item">
          <div class="personalizationPanelControl">
            <div id="personalizationPanelAvatar" class="avatar">
              <span class="userInitials">
                {{sessionData.memberInfo.first_name?.substring(0, 1) | uppercase}}{{sessionData.memberInfo.last_name?.substring(0, 1) |uppercase}}
              </span>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <!--Right Header Area-->
    <div class="header-brand--align-right">

      <div class="header-subnavbrand__container hidden-md hidden-lg">
        <ul class="header-subnavbrand_nav mobile-nav">
          <li class="header-bran__nav-item sor-item" *ngFor="let navItem of findBrandMenus(displayOptions.menus)" (click)="collapseExpandNavItems(navItem);">
            <a class="header-bran__nav-link" href="{{navItem.link_href !== '' ? navItem.link_href : '#'}}">
              {{navItem.text_link}}
              <span [hidden]="navItem.sub_menus.length === 0" [ngClass]="{'menu-collapsed' : navItem.collapsed, 'menu-expanded' : !navItem.collapsed}"></span>
            </a>
            <ul class="header-bran__navsubmenu" *ngIf="(navItem.sub_menus.length !== 0) && !navItem.collapsed">
              <li class="header-subnavbrand_list_item" *ngFor="let submenu of navItem.sub_menus">
                <a href="{{submenu.link_href}}">{{submenu.text_link}}</a>
              </li>
            </ul>
          </li>
        </ul>

        <div class="mobile-language-currency">
          <select class="select" onchange="null">
            <option selected="selected" value="1">English</option>
            <option value="2">Español</option>
            <option value="3">Français</option>
            <option value="4">Português</option>
            <option value="6">Italiano</option>
            <option value="10">简体中文</option>
          </select>
          <select class="select">
            <option value="ARS">ARS - Argentine Peso</option>
            <option value="AUD">AUD - Australian Dollars</option>
            <option value="BWP">BWP - Botswanan Pula</option>
            <option value="BRL">BRL - Brazilian Real</option>
            <option value="GBP">GBP - British Pound</option>
            <option value="CAD">CAD - Canadian Dollars</option>
            <option value="CLP">CLP - Chilean peso</option>
            <option value="CNY">CNY - Chinese Yuan</option>
            <option value="COP">COP - Colombian Peso</option>
            <option value="CRC">CRC - Costa Rican Colón</option>
            <option value="CZK">CZK - Czech Koruna</option>
            <option value="DKK">DKK - Danish Krone</option>
            <option value="EUR">EUR - Euro</option>
            <option value="HKD">HKD - Hong Kong Dollar</option>
            <option value="HUF">HUF - Hungarian forint</option>
            <option value="ISK">ISK - Icelandic króna</option>
            <option value="INR">INR - Indian Rupee</option>
            <option value="IDR">IDR - Indonesian Rupiah</option>
            <option value="ILS">ILS - Israeli New Shekel</option>
            <option value="JPY">JPY - Japanese Yen</option>
            <option value="KES">KES - Kenyan Shilling</option>
            <option value="KWD">KWD - Kuwaiti Dinar</option>
            <option value="MYR">MYR - Malaysian Ringgit</option>
            <option value="MXN">MXN - Mexico Pesos</option>
            <option value="TWD">TWD - New Taiwan Dollar</option>
            <option value="NZD">NZD - New Zealand Dollar</option>
            <option value="NOK">NOK - Norwegian krone</option>
            <option value="PGK">PGK - Papua New Guinean kina</option>
            <option value="PEN">PEN - Peruvian sol</option>
            <option value="PHP">PHP - Philippine Peso</option>
            <option value="PLN">PLN - Polish Zloty</option>
            <option value="QAR">QAR - Qatari Riyal</option>
            <option value="RON">RON - Romanian Leu</option>
            <option value="RUB">RUB - Russian Ruble</option>
            <option value="SAR">SAR - Saudi Riyal</option>
            <option value="RSD">RSD - Serbian Dinar</option>
            <option value="SGD">SGD - Singapore Dollar</option>
            <option value="ZAR">ZAR - South African Rand</option>
            <option value="KRW">KRW - South Korean Wan</option>
            <option value="SEK">SEK - Swedish krona</option>
            <option value="CHF">CHF - Swiss Franc</option>
            <option value="THB">THB - Thai Baht</option>
            <option value="TRY">TRY - Turkish lira</option>
            <option value="AED">AED - United Arab Emirates Dirham</option>
            <option selected="selected" value="USD">USD - US Dollar</option>
            <option value="VND">VND - Vietnamese Dong</option>
          </select>

          <input (click)="toggleCultureDialog()"
                 class="button buttons_standardorange"
                 type="button" value="Apply" />
        </div>
      </div>


      <!--Desktop nav buttons-->
      <div>
        <ul id="homenav" class="header-brand__navbar-nav hidden-xs hidden-sm">

          <li class="header-bran__nav-item sor-item">
            <span class="header-bran__nav-link" *ngIf="isLoyaltyCurrencyAllowed">
              {{loyaltyLabel}} : 
            </span>
            <span class="header-bran__nav-link reward-points" *ngIf="isLoyaltyCurrencyAllowed">
              {{loyalty}}
            </span>
          </li>
          <li class="header-bran__nav-item sor-item" *ngFor="let navItem of findHomeNavMenus(displayOptions.menus)">
            <a class="header-bran__nav-link" href="{{navItem.link_href}}">
              {{navItem.text_link}}
            </a>
          </li>

          <!--TODO: Count of Favorites that the user has saved Favorites(0)-->
          <!--English Currency Item-->
          <li class="header-bran__nav-item">
            <section class="culture-options-trigger" (click)="toggleCultureDialog()">
              <img class="globe-icon" src="assets/images/icon_globe.png">

              <span class="language-text">
                ENG
                <span class="pipe">|</span>
                USD
              </span>
              <span class="chevron-down"></span>
            </section>
            <section class="culture-options-popup" *ngIf="isCultureDialogOpen">
              <select class="select" onchange="null">
                <option selected="selected" value="1">English</option>
                <option value="2">Español</option>
                <option value="3">Français</option>
                <option value="4">Português</option>
                <option value="6">Italiano</option>
                <option value="10">简体中文</option>

              </select>

              <select class="select">
                <option value="ARS">ARS - Argentine Peso</option>
                <option value="AUD">AUD - Australian Dollars</option>
                <option value="BWP">BWP - Botswanan Pula</option>
                <option value="BRL">BRL - Brazilian Real</option>
                <option value="GBP">GBP - British Pound</option>
                <option value="CAD">CAD - Canadian Dollars</option>
                <option value="CLP">CLP - Chilean peso</option>
                <option value="CNY">CNY - Chinese Yuan</option>
                <option value="COP">COP - Colombian Peso</option>
                <option value="CRC">CRC - Costa Rican Colón</option>
                <option value="CZK">CZK - Czech Koruna</option>
                <option value="DKK">DKK - Danish Krone</option>
                <option value="EUR">EUR - Euro</option>
                <option value="HKD">HKD - Hong Kong Dollar</option>
                <option value="HUF">HUF - Hungarian forint</option>
                <option value="ISK">ISK - Icelandic króna</option>
                <option value="INR">INR - Indian Rupee</option>
                <option value="IDR">IDR - Indonesian Rupiah</option>
                <option value="ILS">ILS - Israeli New Shekel</option>
                <option value="JPY">JPY - Japanese Yen</option>
                <option value="KES">KES - Kenyan Shilling</option>
                <option value="KWD">KWD - Kuwaiti Dinar</option>
                <option value="MYR">MYR - Malaysian Ringgit</option>
                <option value="MXN">MXN - Mexico Pesos</option>
                <option value="TWD">TWD - New Taiwan Dollar</option>
                <option value="NZD">NZD - New Zealand Dollar</option>
                <option value="NOK">NOK - Norwegian krone</option>
                <option value="PGK">PGK - Papua New Guinean kina</option>
                <option value="PEN">PEN - Peruvian sol</option>
                <option value="PHP">PHP - Philippine Peso</option>
                <option value="PLN">PLN - Polish Zloty</option>
                <option value="QAR">QAR - Qatari Riyal</option>
                <option value="RON">RON - Romanian Leu</option>
                <option value="RUB">RUB - Russian Ruble</option>
                <option value="SAR">SAR - Saudi Riyal</option>
                <option value="RSD">RSD - Serbian Dinar</option>
                <option value="SGD">SGD - Singapore Dollar</option>
                <option value="ZAR">ZAR - South African Rand</option>
                <option value="KRW">KRW - South Korean Wan</option>
                <option value="SEK">SEK - Swedish krona</option>
                <option value="CHF">CHF - Swiss Franc</option>
                <option value="THB">THB - Thai Baht</option>
                <option value="TRY">TRY - Turkish lira</option>
                <option value="AED">AED - United Arab Emirates Dirham</option>
                <option selected="selected" value="USD">USD - US Dollar</option>
                <option value="VND">VND - Vietnamese Dong</option>

              </select>

              <input (click)="applyCultureChanges()"
                     class="button buttons_standardorange"
                     type="button" value="Apply" />
            </section>
          </li>

          <!--Avatar for Desktop view.-->
          <li class="header-bran__nav-item">
            <div class="personalizationPanelControl" style="display: block;">
              <div id="personalizationPanelAvatar" class="avatar">
                <span class="userInitials">
                  {{sessionData.memberInfo.first_name?.substring(0, 1) | uppercase}}{{sessionData.memberInfo.last_name?.substring(0, 1) |uppercase}}
                </span>
              </div>
              <div id="personalizationPanelUserName" class="userName">
                {{sessionData.memberInfo.first_name}} {{sessionData.memberInfo.last_name}}
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>

<!--SOR Mobile Header-->
<section class="header-brand_subnav sor-brand" [ngClass]="{'mobile-menu--open' : isNavbarExpanded, 'mobile-menu--lg' : wrapNavMenu, 'mobile-menu--sm' : !wrapNavMenu}" *ngIf="showSorMobileNavBar">
  <div class="mobile-scroll-nav hidden-md hidden-lg">
    <ul class="mobile-scroll-nav-list">
      <li *ngFor="let navItem of findMobileBrandMenus(displayOptions.menus)">
        <a class="header-bran__nav-link" href="{{navItem.link_href}}">
          <i class="fal" [ngClass]="{
                       'fa-bed' : navItem.text_link === 'Hotels',
                       'fa-ship' : navItem.text_link === 'Cruises',
                       'fa-car' : navItem.text_link === 'Cars',
                       'fa-plane' : navItem.text_link === 'Flights',
                       'fa-home' : navItem.text_link === 'Homes',
                       'fa-umbrella-beach' : navItem.text_link === 'Weeks',
                       'fa-store' : navItem.text_link === 'Marketplace',
                       'fa-bicycle' : navItem.text_link === 'Activities',
                       'fa-tree-palm' : navItem.text_link === 'Lifestyle'
                    }">

          </i>
          {{navItem.text_link}}
        </a>
      </li>
    </ul>
  </div>
  <div class="header-subnavbrand__container hidden-xs hidden-sm">
    <ul class="header-subnavbrand_nav desktop-nav">
      <li class="header-bran__nav-item sor-item" *ngFor="let navItem of findBrandMenus(displayOptions.menus)">
        <a class="header-bran__nav-link" href="{{navItem.link_href}}">
          {{navItem.text_link}}
          <span [hidden]="navItem.sub_menus.length === 0" class="hidden-sm icon-arrow-down"></span>
          <span [hidden]="navItem.sub_menus.length === 0" class="hidden-md hidden-lg collapsed"></span>
        </a>
        <ul class="header-subnavbrand_list" *ngIf="navItem.sub_menus" [hidden]="navItem.sub_menus.length === 0">
          <li class="header-subnavbrand_list_item" *ngFor="let submenu of navItem.sub_menus">
            <a href="{{submenu.link_href}}">{{submenu.text_link}}</a>
          </li>
        </ul>
      </li>
    </ul>
  </div>

</section>
